<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="loading">
                <b-row>
                    <b-col lg="10" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                                <ValidationProvider name="Sales Center Name (en)" vid='sales_center_name_en' rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="sales_center_name_en"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{ $t('production_service_config.sales_name_en')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="sales_center_name_en"
                                        v-model="sales_center_info.sales_center_name_en"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider name="Sales Center Name (bn)" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="sales_center_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{ $t('production_service_config.sales_name_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="sales_center_name_bn"
                                        v-model="sales_center_info.sales_center_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider name="area_type_id" vid="area_type_id" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="area_type_id "
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('org_pro.area_type')}}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.area_type_id"
                                        id="area_type_id"
                                        :options="getAreaTypeList"
                                        @change="getAreaTypeData(sales_center_info.area_type_id)"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="ItemShow" name="Division" vid="division_id" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="division_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{ $t('org_pro_division.division')}}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.division_id"
                                        :options="divisionList"
                                        id="division_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="ItemShow" name="District" vid="district_id" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="district_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{ $t('org_pro_district.district')}}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.district_id"
                                        :options="districtList"
                                        id="district_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="PauroshobaItemShow || UnionItemShow" name="Upazila" vid="upazila_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="upazila_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{ $t('org_pro_upazilla.upazilla')}}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.upazilla_id"
                                        :options="upazilaList"
                                        id="upazila_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="UnionItemShow" name="Union" vid="union_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="union_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{ $t('org_pro_union.union')}}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.union_id"
                                        :options="unionList"
                                        id="union_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="CityCorpItemShow" name="City Corporation" vid="city_corporation_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="city_corporation_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('org_pro.city_corporation') }}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.city_corporation_id"
                                        :options="cityCorporationList"
                                        id="city_corporation_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="PauroshobaItemShow" name="Municipality" vid="pauroshoba_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="pauroshoba_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('org_pro.pauroshoba') }}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.pauroshoba_id"
                                        :options="pauroshobaList"
                                        id="pauroshoba_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider v-show="ItemShow" name="Ward" vid="ward_id" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="ward_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('org_pro.ward') }}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="sales_center_info.ward_id"
                                        :options="wardList"
                                        id="ward_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider name="Address (en)" vid='address' rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="address_en"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{ $t('production_service_config.address_en')}}
                                        </template>
                                        <b-form-input
                                        id="address"
                                        v-model="sales_center_info.address_en"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider name="Address (bn)" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="address_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{ $t('production_service_config.address_bn')}}
                                        </template>
                                        <b-form-input
                                        id="address_bn"
                                        v-model="sales_center_info.address_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '../../../../../config/api_config'
import { SalesCenterInfoStore, SalesCenterInfoUpdate } from '../../api/routes'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            if (this.item.area_type_id === 1) {
                this.ItemShow = true
                this.CityCorpItemShow = true
                this.PauroshobaItemShow = false
                this.UnionItemShow = false
            } else if (this.item.area_type_id === 2) {
                this.ItemShow = true
                this.CityCorpItemShow = false
                this.PauroshobaItemShow = true
                this.UnionItemShow = false
            } else if (this.item.area_type_id === 3) {
                this.ItemShow = true
                this.CityCorpItemShow = false
                this.PauroshobaItemShow = false
                this.UnionItemShow = true
            }
            const tmp = this.getSalesCenterInfoData()
            this.sales_center_info = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            ItemShow: false,
            CityCorpItemShow: false,
            PauroshobaItemShow: false,
            UnionItemShow: false,
            loading: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            sales_center_info: {
                sales_center_name_en: '',
                sales_center_name_bn: '',
                area_type_id: '0',
                city_corporation_id: '0',
                pauroshoba_id: '0',
                division_id: '0',
                district_id: '0',
                upazilla_id: '0',
                union_id: '0',
                ward_id: '0',
                address_en: '',
                address_bn: '',
                created_by: 1,
                updated_by: 1
            },
            districtList: [],
            upazilaList: [],
            unionList: [],
            cityCorporationList: [],
            pauroshobaList: [],
            wardList: []
        }
    },
    computed: {
        getAreaTypeList: function () {
            const objectData = this.$store.state.commonObj.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        }
    },
    watch: {
        'sales_center_info.division_id': function (newVal, oldVal) {
            this.districtList = this.getDistrictList(newVal)
        },
        'sales_center_info.district_id': function (newVal, oldVal) {
            this.cityCorporationList = this.getCityCorporationList(newVal)
            this.upazilaList = this.getUpazilaList(newVal)
        },
        'sales_center_info.upazilla_id': function (newVal, oldVal) {
            this.unionList = this.getUnionList(newVal)
            this.pauroshobaList = this.getPauroshobaList(newVal)
        },
        'sales_center_info.city_corporation_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByCityCorportaion(newVal)
        },
        'sales_center_info.pauroshoba_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByPauroshoba(newVal)
        },
        'sales_center_info.union_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByUnion(newVal)
        }
    },
    methods: {
        getAreaTypeData (typeId) {
            this.ItemShow = true
            if (typeId === 1) {
                this.CityCorpItemShow = true
                this.PauroshobaItemShow = false
                this.UnionItemShow = false
            } else if (typeId === 2) {
                this.CityCorpItemShow = false
                this.PauroshobaItemShow = true
                this.UnionItemShow = false
            } else if (typeId === 3) {
                this.CityCorpItemShow = false
                this.PauroshobaItemShow = false
                this.UnionItemShow = true
            }
        },
        getSalesCenterInfoData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
        },
        async saveData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            this.loading = true
            if (this.id) {
                result = await RestApi.putData(productionServiceBaseUrl, `${SalesCenterInfoUpdate}/${this.id}`, this.sales_center_info)
            } else {
                result = await RestApi.postData(productionServiceBaseUrl, SalesCenterInfoStore, this.sales_center_info)
            }

            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                color: '#D6E09B'
                })

                this.$bvModal.hide('modal-4')
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        },
        getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }

            return districtList
        },
        getUpazilaList (districtId = null) {
            const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

            if (districtId) {
                return upazilaList.filter(upazila => upazila.district_id === districtId)
            }

            return upazilaList
        },
        getUnionList (upazilaId = null) {
            const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
            if (upazilaId) {
                return unionList.filter(union => union.upazilla_id === upazilaId)
            }

            return unionList
        },
        getCityCorporationList (districtId) {
            const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getPauroshobaList (upazillaId = null) {
            const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
            if (upazillaId) {
                return objectData.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            }
        },
        getWardListByCityCorportaion (cityCorpId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getWardListByPauroshoba (pauroshobaId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getWardListByUnion (unionId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        }
    }
}
</script>
